import api from ".";

import cookiesModifier from "../utils/cookies";

export const getTags = async () => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.get(`tags`);

        return res.data;
    } catch (error) {
        throw error;
    }
};

export const reorderTags = async (id: number, order: 'up' | 'down') => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.patch(`tags/reorder/${id}/${order}`);

        return res.data;
    } catch (error) {
        throw error;
    };
};